import { flow, Instance, types } from 'mobx-state-tree';
import { User } from '../model/user';
import { YoUser } from '@yakoffice/yakoffice-firebase';
import { PortalApiGateway } from '../apiGateway/PortalApiGateway';
import { MapToUserModel } from './mappers/map-user';


export const UserStore = types.model(
    'UserStore',
    {
        apiGateway: PortalApiGateway,
        users: types.array(User)
    })
    .actions(self => ({
        addUser() {
            const user = User.create({ isNew: true, projects: [] });
            self.users.replace([user]);

        },
        loadUser: flow(function* (email: string) {
            try {
                const requestedUser: YoUser = yield self.apiGateway.getUser(email);
                const user = User.create(MapToUserModel(requestedUser));
                self.users.replace([user]);
            } catch (e: any) {
                throw new Error(`Failed to load user: ${e.message}`);
            }
        }),
        saveUser: flow(function* () {
            try {
                yield self.apiGateway.updateUser(self.users[0]);
            } catch (e: any) {
                throw new Error(`Failed to save user: ${e.message}`);
            }
        }),
        deleteUser: flow(function* () {
            try {
                yield self.apiGateway.deleteUser(self.users[0].email);
            } catch (e: any) {
                throw new Error(`Failed to save user: ${e.message}`);
            }
        }),
        loadUserForProject: flow(function* (projectId: string, userEmail: string) {
            try {
                const requestedUser: YoUser = yield self.apiGateway.getUserForProject(projectId, userEmail);
                const user = User.create(MapToUserModel(requestedUser));
                self.users.replace([user]);
            } catch (e: any) {
                throw new Error(`Failed to load user for project ${projectId}: ${e.message}`);
            }
        }),
        updateUserForProject: flow(function* (projectId: string) {
            try {
                yield self.apiGateway.updateUserForProject(projectId, self.users[0]);
            } catch (e: any) {
                throw new Error(`Failed to update user ${self.users[0].email} for project ${projectId}: ${e.message}`);
            }
        }),
        deleteUserForProject: flow(function* (projectId: string) {
            try {
                self.users[0].removeProjectFromUser(projectId);
                yield self.apiGateway.updateUserForProject(projectId, self.users[0]);
            } catch (e: any) {
                throw new Error(`Failed to update user ${self.users[0].email} for project ${projectId}: ${e.message}`);
            }
        })
    }));

export interface IUserStore extends Instance<typeof UserStore> {
}
